import React, { Component,Fragment } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Field, reduxForm, change,
	formValueSelector,stopAsyncValidation,touch,reset } from 'redux-form'
import {getFormValues} from 'redux-form/immutable'
import { DefaultPlayer as Video } from 'react-html5video'
import map from 'async/map'
import isEmpty from 'lodash/isEmpty'
import bindAll from 'lodash/bindAll'
import Promise from 'bluebird'
import $ from 'jquery'
import snakeCase from 'voca/snake_case'
import UAParser from 'ua-parser-js'
import imgDefaultLogo from '../../../images/public/company_empty.png'
import imgSubmitted from '../../../images/submitted.svg'
import imgAppStore from '../../../images/public/appstore.png'
import imgGooglePlay from '../../../images/public/googleplay.png'
import imgAstrntFooter from '../../../images/public/logo-astronaut.svg'
import imgDocSubmitted from '../../../styles/img/doc-submitted.svg'
import imgExpired from '../../../styles/img/expired-calendar.svg'
import ProgressBarAngga from '../../partials/ProgressBarAngga'
import ProgressBarMultiDoc from '../../partials/ProgressBarMultiDoc'
import CheckBoxGroup from '../../partials/CheckBoxGroup'
// import validate from './validate'
import validate from './validationMultiUploadDoc'
import { Map, fromJS } from 'immutable'
// import Swal from 'sweetalert2'
import _axios from '../../../dependencies/_axios'
// import { EmailShareButton, FacebookShareButton, TwitterShareButton, LinkedinShareButton, WhatsappShareButton } from 'react-share'
import moment from 'moment'
import {
	publicJobGetDetail,
	registrationSaveData,
	publicJobGetDetailAsync,
	registrationSaveDataError,
	publicDocumentGetJobDetail,
	registrationSaveDataCode
} from '../../../actions/public/companies'


import {
    t} from '../../../helpers/global'

import {
	globalHideSweetAlert,
	globalAddSweetAlertData
} from '../../../actions/global'

import {
	docAttachment,
	docAttachmentUpload,
	send,
} from '../../../actions/public/document'

import { accessLog } from '../../../actions/global'
import FileUploader from '../../partials/FileUploader'
import LinkInputer from '../../partials/LinkInputer'

require('es6-promise').polyfill()

export const fields = ['file']

type State = {
  isConsent: boolean,
  isSaved: boolean
};

const ACCEPTED_MULTI_DOC = [
	'image/png',
	'image/jpg',
	'image/jpeg',
	'audio/mpeg',
	'audio/mp3',
	'audio/mp4',
	'video/avi',
	'video/mp4',
	'application/mp4',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'application/msword',
	'application/vnd.ms-word.document.macroEnabled.12',
	'application/vnd.oasis.opendocument.formula',
	'application/pdf',
	'application/vnd.ms-excel',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	'text/csv',
	'application/vnd.oasis.opendocument.text',
	'application/vnd.oasis.opendocument.spreadsheet',
];

const normalizeEmail = (value, previousValue) => {
	return value.trim()
}

const renderTime = (job)=> {
	return job.timezone ? job.timezone.suffix : '(GMT+7)'
}

const normalizeTextLenght = (value,previousValue,maxWords)=>{
		let countText;
		if (value.trim().length == 0) {
      countText = 0;
    } else {
      countText = value == "" ? 0 : value.match(/\S+/g).length;
    }

		if (countText <= maxWords  ) {
			return value
		}else{
			return previousValue
		}
	}


const regexLinkCheck  = (value)=>{
	var expression =/(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
	var regex = new RegExp(expression);

	if (value.match(regex)) {
		return true
	} else {
		return false
	}
}

const validateDoc = (value, allValues, props) => {
  // naturally you do something else here if the value
  // used to determine whether this field is required or
  // not is not managed by the same redux form
  const isRequired = allValues.commentRequired === 'Yes'

  if (isRequired && !value) return "Can't be empty."
}


const getExt = (files)=> {
	let fileName = files.name
	fileName = fileName.substr(fileName.lastIndexOf('.') + 1)
	return fileName
};

const getFilename = (files)=> {
	let fileName = files.name
	fileName = fileName.substring(0, fileName.lastIndexOf('.'))
	return fileName
};

let pollingUpload = null



/**
 * Formalize file.slice
 */

function slice(file, start, end) {
  var slice = file.mozSlice ? file.mozSlice :
              file.webkitSlice ? file.webkitSlice :
              file.slice ? file.slice : noop;
  
  return slice.bind(file)(start, end);
}

function noop() {
  
}

class UploadExpired extends Component {
	constructor(props) {
		super(props)

		this.state = {
			file: '',
			experience: '0',
			name: '',
			email: '',
			code: '',
			url: '',
			isConsent: false,
			isCompliance:false,
			isSaved: false,
			uploadFilePercentage:'',
			testColor:'#564FDB',
			uploadProgress:'',
			cvName:'',
			isWhatsappReminder:true,
			error_exist: false,
			formDocumentList:[],
			targetIndexUpload:'',
			lastAttachmentIndex:0,
			showPopUp:0,
		}
		this.uploadRef = React.createRef();

		bindAll(this, [
			'handleSaveData',
			'imageOnError',
			'renderError',
			'renderErrorCV',
			'removeRegexCharacter',
			'handleFileUpload',
			'checkExperience',
			'removeSpaceCharacter',
			'handleClickAfterSave',
			'handleFileSave',
			'handleChangeTextArea',
			'inputFocus',
			'inputBlur',
			'handlePopUp',
			'countWord',
			'resizeTextArea',
			'removeErrorMessage',
			'renderMultiDocForm',
			'addLinkInputerForm',
			'handleRemoveInputLink',
			'handleFieldLinkChange',
			'checkCanAddFieldLink',
			'checkLinkErrorValue',
			'checkFieldFormDocument',
			'renderErrorNoTranslation',
			'handleAttachmentUpload',
			'uploadAttachments',
			'handleRemoveFile',
			'handleReuploadFile',
			'handleCancelUpload',
			'processFile',
			"promisedSetState",
			"renderErrorFileState",
			"showPopUpModal",
		])
	}

	//this function to be used as await
  promisedSetState(newState){
		return new Promise(resolve => this.setState(newState, resolve));
	} 

	showPopUpModal(){
		const{globalAddSweetAlertData,globalHideSweetAlert}=this.props
		if (this.state.showPopUp == 0) {
			this.setState({showPopUp:1})
			globalAddSweetAlertData({
				show: true,
				title: 'It takes longer to upload',
				html: true,
				text: 'It seems that we need more time to upload your documents.<br/>Please wait until the upload process is complete.',
				confirmButtonText: 'OK',
				confirmButtonColor: '#564FDB',
				onConfirm: () => {
					globalHideSweetAlert()
				}
				})
		}
	}

 processFile(files,company_id,reducerIndex,indexDocument,indexAttachment,startData=null,new_file=0) {
	const{send}=this.props
	var file = files;
	var extension = `.${getExt(files)}`
	var fileName = getFilename(files)
	var size = file.size;
	// var sliceSize = 25600;
	var isNewFile = new_file
	var sliceSize = 1000024;
	var start = 0;
	if (startData) {
		start = startData
	}
	let $this = this
	var lastData = 0
	// pollingUpload = setTimeout(loop, 300);
	
	// let formDocumentList =  this.state.formDocumentList[indexDocument]
	// let originFormDocumentList = this.state.formDocumentList
	
	// formDocumentlist.attachment[indexAttachment].pollingFunc = setTimeout(loop, 100);
	// console.log(originFormDocumentList[indexDocument].attachment[indexAttachment].pollingFunc)
	
	// originFormDocumentList[indexDocument].attachment[indexAttachment].pollingFunc = setTimeout(loop, 100);
	// await this.promisedSetState({formDocumentList:originFormDocumentList})
	// let $this = this
		function loop() {
		var end = start + sliceSize;
		
		if (size - end < 0) {
			end = size;
		}
		
		//expect datanya as string 
		//ex: bisa di liat di qna proctoring sendBlobAsBase64
		var s = slice(file, start, end);
		//case dipause ambil start dan end variable sebelum di read
		//nanti bisa continue dengan start end nya saatdicancel
		const reader = new FileReader();

		reader.addEventListener("load", () => {
			const dataUrl = reader.result;
			// console.log(dataUrl);
			const base64EncodedData = dataUrl.split(",")[1];
	
			/**Needed if for example usage */
			//dataUrl.split(",")[2] for video
			//dataUrl.split(",")[1] for audio
			//example below video
			// const encodedData = dataUrl.split(',')[2];
			// const base64EncodedData = opus + ',' + encodedData
			// console.log(base64EncodedData,'datanyan');
			console.log(size,'di loop')
			send(company_id,base64EncodedData, extension,fileName,reducerIndex,end,start,size,isNewFile).then((res)=>{
				console.log(res,'respondnya')
				if (res == 'longupload') {
					$this.showPopUpModal()
				}
				if (end < size) {
					start += sliceSize;
					isNewFile=0
					// originFormDocumentList[indexDocument].attachment[indexAttachment].pollingFunc = setTimeout(loop, 300);
					// await $this.promisedSetState({formDocumentList:originFormDocumentList})
					loop()
					// pollingUpload=setTimeout(loop, 100);
				}
			})
			.catch((error)=>{
				$this.showPopUpModal()
			})
		});
	
		reader.readAsDataURL(s);
		
		

		// if (end < size) {
		// 	start += sliceSize;
		// 	originFormDocumentList[indexDocument].attachment[indexAttachment].pollingFunc = setTimeout(loop, 300);
		// 	await $this.promisedSetState({formDocumentList:originFormDocumentList})
			
		// 	// pollingUpload=setTimeout(loop, 100);
		// }
	}
	loop()
}

	handleCancelUpload(e,identifier,indexDocument,indexAttachment){
		const{
			publicJobDetail,
			docAttachmentUpload,
			docAttachment,
			documentAttachment,
		}=this.props
		
		// let originFormDocumentList = this.state.formDocumentList
		// if (originFormDocumentList[indexDocument].attachment[indexAttachment].pollingFunc) {
    //   clearTimeout(originFormDocumentList[indexDocument].attachment[indexAttachment].pollingFunc);
    // }


		let indexFileAttached = 0
		let result  = documentAttachment.file_attachment.map((val,index)=> {
			
			if (val.identifier == identifier) {
				indexFileAttached = index
				return val
			}
		})
		
		const current_files = documentAttachment.file_attachment
		const tokenCancel = current_files[indexFileAttached]['tokenCancel']
		if (tokenCancel) {
			tokenCancel.cancel('canceled')
			current_files[indexFileAttached]['status'] = 'failed'
			docAttachment(current_files)
		}
		

	}

	handleReuploadFile(e,identifier,indexDocument,indexAttachment){
		const{
			publicJobDetail,
			docAttachmentUpload,
			docAttachment,
			documentAttachment,
		}=this.props
		let company = publicJobDetail.company
		// let formDocumentList =  this.state.formDocumentList[indexDocument].attachment[]
		let originFormDocumentList = this.state.formDocumentList
		originFormDocumentList[indexDocument].attachment[indexAttachment].errorMessage = '';
		this.setState({formDocumentList:originFormDocumentList})
		console.log(documentAttachment.file_attachment,'DOCUMENT ATTACH')
		let indexFileAttached = 0
		let result  = documentAttachment.file_attachment.map((val,index)=> {
			
			if (val.identifier == identifier) {
				indexFileAttached = index
				return val
			}
		})
		
		const current_files = documentAttachment.file_attachment
		current_files[indexFileAttached]['status'] = 'loading'
		let sizeUnit = current_files[indexFileAttached]['sizeUnit'] 
		let startSize  = current_files[indexFileAttached]['startSize']
		docAttachment(current_files)
		.then(()=>{
			if (sizeUnit == 'MB') {
				this.processFile(current_files[indexFileAttached]['originalFile'],company.id,indexFileAttached,indexDocument,indexAttachment,startSize)
			}else{
				docAttachmentUpload(company,current_files[indexFileAttached]['originalFile'],indexFileAttached)
			}
		})
	}

	handleRemoveFile(e,indexDocument,indexAttachment){
		const{changeFieldValue}=this.props;
		console.log('clicked')
		let formDocumentList =  this.state.formDocumentList[indexDocument]
		let originFormDocumentList = this.state.formDocumentList
		const current_files = formDocumentList.attachment
		formDocumentList.attachment = current_files.filter((val,ind)=>
			ind !== indexAttachment
		)
		originFormDocumentList[indexDocument] = formDocumentList
		if (formDocumentList[indexDocument].attachment.length<=0) {
			if (formDocumentList[indexDocument].link_input) {
				if (formDocumentList[indexDocument].link_input.length<=0) {
					changeFieldValue(`${formDocumentList.type.replace(/\./g,' ')}`,'')
				}
			}
			
		}
		this.setState({formDocumentList:originFormDocumentList})
	
	}

	handleAttachmentUpload(e){
		let $this = this;
		// console.log(this.state.targetIndexUpload,'targetIndex')
		// console.log(e.target,'isi e')
		// if (e.target.files[0].size > 1000000000) {
		// 	globalAddSweetAlertData({
		// 		show: true,
		// 		title: t(translation,'FILE_SIZE_EXCEED_LANDING_PAGE'),
		// 		text: `It will take the upload time longer than usual. Do you still want to proceed?`,
		// 		confirmButtonText: 'OK',
		// 		confirmButtonColor: '#ED2453',
		// 		cancelButtonText: "Cancel",
		// 		showCancelButton: true,
		// 		customClass: 'swal-alert-mobile',
		// 		showLoaderOnConfirm: true,
		// 		onCancel: () => {

		// 			return globalHideSweetAlert()
		// 		},
		// 		onConfirm: () => {
		// 			//restore list
		// 			$this.uploadAttachments(e.target.files,$this.state.targetIndexUpload)
					
		// 		}
		// 	})
		// }

		this.uploadAttachments(e.target.files,this.state.targetIndexUpload)
		

		// processFile(e.target.files)
	}
	uploadAttachments(files,targetIndexDocument) {
		const{
			publicJobDetail,
			docAttachmentUpload,
			docAttachment,
			documentAttachment,
			touchForm,
			stopAsyncValidationForm,
			changeFieldValue,
			globalAddSweetAlertData,
			globalHideSweetAlert,
		}=this.props
		let company = publicJobDetail.company
		// return processFile(files,company.id)
		
		let formDocumentList =  this.state.formDocumentList[targetIndexDocument]
		let originFormDocumentList = this.state.formDocumentList
		


		
		
		if (formDocumentList.attachment) {
		
		}else{
			formDocumentList.attachment = []
		}

		const current_files = formDocumentList.attachment
		let outputFilesState = current_files
		let outputFiles = documentAttachment.file_attachment
		
		//checkDocumentName
		let checkSameFile = 0
		current_files.map((v,i)=>{
			if (v.filename == files[0].name) {
				checkSameFile=1
			}
		})
		if (checkSameFile) {
			return globalAddSweetAlertData({
				show: true,
				title: 'Document already exists',
				html: true,
				text: 'You can’t upload the same document. Please try to upload another document.',
				confirmButtonText: 'Ok',
				confirmButtonColor: '#564FDB',
				onConfirm: () => {
					globalHideSweetAlert()
				}
				})
		}

				let size_current_files = current_files.length;
						if (current_files.size>0) {
								size_current_files=0
								outputFiles.map((value)=>{
										if (value.sizeUnit == 'KB') {
												size_current_files += (value.sizeFile/1000)
										}else{
												size_current_files += value.sizeFile
										}
										
								})
						}

				let found_exceedSize = 0
				let found_invalidType= 0
						let $this = this
						let lastAttachmentIndex = this.state.lastAttachmentIndex
				Object.keys(files).map((index)=>{
					let file_size = Math.round(files[index].size / 1028576)
					let file_unit_value = 'MB'
					let exceedSize = 0
					let invalidType= 0
				

					// if (!ACCEPTED_MULTI_DOC.includes(files[index].type)) {
					// 	invalidType = 1
					// 	found_invalidType = 1
					// }

					if (file_size < 1) {
						file_size = Math.round(files[index].size / 1028)
						file_unit_value = 'KB'
					}

					if (exceedSize || invalidType ) {
						console.log('masuk sini')
					}else{			
												const dateMod = Date.now();
												outputFiles.push({
														"filename": files[index].name,
														"type": files[index].type,
														"url": null, /** NULL for post, not NULL for unchange-put */
														"filepath": "",
														"status":"loading",
														"showBarProgress":1,
														"progress":"",		
														"sizeFile":file_size,
														"sizeUnit": file_unit_value,
														"progressFile":0,	
														"originalFile":files[index],
														"lastModified":dateMod,
														"identifier": lastAttachmentIndex,
														"tokenCancel":"",
														"startSize":0,
														"endSize":0,
												});
												outputFilesState.push({
														"filename": files[index].name,
														"type": files[index].type,
														"url": null, /** NULL for post, not NULL for unchange-put */
														"filepath": "",
														"status":"loading",
														"showBarProgress":1,
														"progress":"",		
														"sizeFile":file_size,
														"sizeUnit": file_unit_value,
														"progressFile":0,	
														"originalFile":files[index],
														"lastModified":dateMod,
														"identifier": lastAttachmentIndex,
														"tokenCancel":"",
														"startSize":0,
														"endSize":0,
														"pollingFunc":0,
														"errorMessage":"",
												})
												files[index].identifier = lastAttachmentIndex
												console.log(outputFiles, 'output files')
												console.log(outputFilesState, 'output state')
												docAttachment(outputFiles)
												.then(()=>{
														// $this.setState({templateIsChanged:1})
														let obj = null
														let obj_index = -1
														outputFiles.map((_r, _i) => {
																if(_r.identifier == files[index].identifier) {
																		obj = _r
																		obj_index = _i
																}
														})
														
														formDocumentList.attachment = outputFilesState
														originFormDocumentList[targetIndexDocument] = formDocumentList
														this.setState({formDocumentList:originFormDocumentList},()=>{
															if (file_size>1) {
																let indexAttachment = 0;
																outputFilesState.map((value,index)=>{
																	if (value.identifier == lastAttachmentIndex) {
																		indexAttachment = index
																	}
																})
																// lastAttachmentIndex adalah identifier 
																this.processFile(files[index],company.id,obj_index,targetIndexDocument,indexAttachment,null,1)
															}else{
																docAttachmentUpload(company.id,files[index],obj_index,dateMod)
															}
														})
														// docAttachmentUpload(company.id,files[index],obj_index,dateMod)
														
														// console.log({file:files[index], obj, obj_index, outputFiles})
														
														
														
												})
												changeFieldValue(`${formDocumentList.type.replace(/\./g,' ')}`,'changes')
												lastAttachmentIndex++;
												this.setState({lastAttachmentIndex})
										
					}
				})

				// if (found_exceedSize || found_invalidType ) {
				// 				let files = []
				// 	if (found_exceedSize) {
				// 		files.push('The file you selected may not be greater than 25 MB.')
				// 	}
				// 	if (found_invalidType) {
				// 		files.push('Your selected file is not supported for upload. Make sure you upload PDF, Spreadsheet file (xls, xlsx, ods, csv), Document file (docs, doc, docx, odf), or Media file (mp3, flv, mp4, jpeg, png, jpg).')
				// 	}
				// 	this.setState({ errorAttachment: files })
					// touchForm(['files'])
					// stopAsyncValidationForm({files})
				// }

		
		


		}

	checkFieldFormDocument(){
		let formDocumentList =  this.state.formDocumentList
		console.log(formDocumentList)

	}

	checkLinkErrorValue(objectDocument,ind,objectInput){
		let every_link = objectDocument.link_input
		if (objectInput.change == 1) {
			let message = ''
		

			if(!regexLinkCheck(objectInput.value)){
				message =  'Invalid Url'
			}

			if(objectInput.value.trim()==''){
				message = `The link can't be blank`
			}

			every_link = every_link.filter((val,idx)=> idx != ind)

			every_link.map((val,idx)=>{
				if (objectInput.value == val.value) {
					message = `The links can't be the same`
				}
			})

			return message
		
		}
	}

	checkCanAddFieldLink(index){
		let arrayValues =  this.state.formDocumentList[index]
		let result = true
		// console.log('kecheck')
		if (arrayValues.link_input) {
			arrayValues.link_input.map((res,index)=>{
				if (res.value.trim() == '') {
					result = false
				}
			})
			
			return result
		}
		return result
	
	}

	handleFieldLinkChange(e,idxCont,idxField){
		const{changeFieldValue}=this.props;
		const text = e.target.value
		console.log('triggered')
		let formDocumentList =  this.state.formDocumentList

		changeFieldValue(`${formDocumentList[idxCont].type.replace(/\./g,' ')}`,text)
		formDocumentList[idxCont].link_input[idxField].value = text 
		formDocumentList[idxCont].link_input[idxField].change = 1 
		this.setState(formDocumentList);
	}

	handleRemoveInputLink(e,idxCont,idxField,label){
		const {changeFieldValue} = this.props
		let formDocumentList =  this.state.formDocumentList
		let link_input = this.state.formDocumentList[idxCont].link_input
	
		link_input = link_input.filter((val,index) => index != idxField)
		
		formDocumentList[idxCont].link_input = link_input
		
		if (formDocumentList[idxCont].link_input.length<=0) {
			if (formDocumentList[idxCont].attachment) {
				if (formDocumentList[idxCont].attachment.length<=0) {
					changeFieldValue(`${label.replace(/\./g,' ')}`,'')
				}
			}
			
		}
		this.setState(formDocumentList);
	}

	addLinkInputerForm(e,index,label){
		const {changeFieldValue} = this.props
		if (this.checkCanAddFieldLink(index)) {
			let formDocumentList = this.state.formDocumentList
			if (formDocumentList[index].link_input) {
				formDocumentList[index].link_input.push({value:'',change:0})
			}else{
				formDocumentList[index].link_input=[]
				formDocumentList[index].link_input.push({value:'',change:0})
			}
			changeFieldValue(`${label.replace(/\./g,' ')}`,'changes')
			this.setState({formDocumentList})
		}
		
	}

	renderMultiDocForm(){
		const{
			documentAttachment,
			
		}=this.props
		const fileAttachmentReducer  = documentAttachment.file_attachment
		const formDocumentList = this.state.formDocumentList
		let documentFormList = []
		formDocumentList.map((value,index)=>{
			if (value.option_value>0) {
				if (index == 0) {
					let label = `${value.type}`
					if (value.option_value == 1) {
						label = `${value.type} (Optional)`
					}
					let uploaded = false
					let file_uploader = []
					if (value.attachment) {
						if (value.attachment.length>0) {
							uploaded = 1
						}
						const attachment = value.attachment
						attachment.map((rs,idx)=>{
							const objectNya = fileAttachmentReducer.filter((v,i)=>v.identifier == rs.identifier)
							file_uploader.push(
								<Fragment>
								<FileUploader handleCancelUpload={(e)=>{this.handleCancelUpload(e,rs.identifier,index,idx)}} handleReuploadFile={(e)=>{this.handleReuploadFile(e,rs.identifier,index,idx)}} handleRemoveFile={(e)=>{this.handleRemoveFile(e,index,idx)}}  key={idx} data_file={objectNya[0]}/>
									{this.renderErrorFileState(rs.errorMessage)}
								</Fragment>
								)
						})
					}

					documentFormList.push(
						<div className='div-multidoc-action'>
					
								
								<div className='horizontal-item--between m-b-8'>
									<label>{label}</label>
									<div className='div-action-icon'>
									<Field name={label}component={this.renderErrorNoTranslation}/>
										<i className='icon-i-add-link-navy hide'></i>
										<i onClick={(e)=>{
												this.setState({targetIndexUpload:index},()=>{
													if (!uploaded) {
														this.uploadRef.current.click();
													}
												})
												
										}} className={`icon-i-add-file m-l-8 ${uploaded? 'disabled':''}`}></i>
									
									</div>
								</div>
								{file_uploader}
							</div>
						)
				}else{
					let label = `${value.type}`
					if (value.option_value == 1) {
						label = `${value.type} (Optional)`
					}
					let inputLink = []

					let file_uploader = []
					if (value.attachment) {
						const attachment = value.attachment
						attachment.map((rs,idx)=>{
							const objectNya = fileAttachmentReducer.filter((v,i)=>v.identifier == rs.identifier)
							file_uploader.push(
								<Fragment>
								<FileUploader handleCancelUpload={(e)=>{this.handleCancelUpload(e,rs.identifier,index,idx)}} handleReuploadFile={(e)=>{this.handleReuploadFile(e,rs.identifier,index,idx)}} handleRemoveFile={(e)=>{this.handleRemoveFile(e,index,idx)}} key={idx} data_file={objectNya[0]}/>
								{this.renderErrorFileState(rs.errorMessage)}
								</Fragment>
							)
						})
					}

					if (value.link_input) {
						let link_input = value.link_input;
						link_input.map((res,ind)=>{
							inputLink.push(
							<Fragment>
								<LinkInputer handleOnChangeText={(e)=>this.handleFieldLinkChange(e,index,ind)} value={res.value} handleDelete={(e)=>{this.handleRemoveInputLink(e,index,ind,label)}}/>
								<span className="error">{this.checkLinkErrorValue(value,ind,res)}</span>
							</Fragment>
							)
						})
						// for (let idx = 0; idx < value.link_input; idx++) {
						// 	 inputLink.push(<LinkInputer/>);
							
						// }
					}
					
					documentFormList.push(
						<div className='div-multidoc-action'>
								<div className='horizontal-item--between m-b-8'>
									<label>{label}</label>
									<Field name={label.replace(/\./g,' ')} component={this.renderErrorNoTranslation}/>
									<div className='div-action-icon'>
										<i onClick={(e)=>this.addLinkInputerForm(e,index,label)} className={`icon-i-add-link-navy ${this.checkCanAddFieldLink(index)? '' : 'disabled'}`}></i>

										<i onClick={(e)=>{
													this.setState({targetIndexUpload:index},()=>{
														this.uploadRef.current.click();
													})
										}} className='icon-i-add-file-navy m-l-8'></i>
										
									</div>
								</div>
								{file_uploader}
								{/* <FileUploader/> */}
								{inputLink}
							</div>
					)
				}
				
			}
		})

		return documentFormList

	}

	countWord(value){

			if (value) {
				let countText;
				if (value.trim().length == 0) {
					countText = 0;
				} else {
					countText = value == "" ? 0 : value.match(/\S+/g).length;
				}
				return countText
			} else {
				return 0
			}


	}


	handlePopUp(value){
		const {publicJobDetail} = this.props
		const company = publicJobDetail.company || {}
		const job = publicJobDetail.job || {}

		const parser: Object = new UAParser();
		const isMobile: boolean = parser.getDevice().type === 'mobile'

		var thisPageURL = window.location.href
		var url = ''
		if(value == 'facebook'){
			  url = 'https://www.facebook.com/sharer/sharer.php?&u='+thisPageURL
				// 'http://www.facebook.com/dialog/feed?'+
				//	'app_id='+thisPageURL
				// 			'link='+thisPageURL+
				// 			'message=Join us. Click here: '+thisPageURL
		}
		if(value == 'Whatsapp' && isMobile){
			  url = 'https://api.whatsapp.com/send?text=Join us. Click here: '+thisPageURL
		} else if (value == 'Whatsapp') {
			url = 'https://web.whatsapp.com/send?text=Join us. Click here: '+thisPageURL
		}
		if(value == 'linkedin'){
			  url = 'https://www.linkedin.com/sharing/share-offsite/?url='+thisPageURL
		}
		if(value == 'twitter'){
			  url = 'https://twitter.com/intent/tweet?url='+thisPageURL+'&text=Join us. Click here: '
		}
		if(value == 'email'){
			  url ='mailto:?subject=Apply Now: '+job.title+' at '+company.title+'&body=Join us. Click here: '+thisPageURL
		}
		window.open(url,'popUpWindow','height=600,width=600,left=400,top=100,resizable=yes,scrollbars=yes,toolbar=yes,menubar=no,location=no,directories=no, status=yes')
	}
	inputFocus(e:object):void{
		const {publicJobCustom}= this.props
		e.target.style.boxShadow = `0 0 10px ${publicJobCustom.color}`;
		e.target.style.border = `1px solid ${publicJobCustom.color}`;
		e.target.style.borderRadius = `5px`;
	}

	inputBlur(e:object):void{
	 	e.target.style.border = `1px solid #999999`
		 e.target.style.borderRadius= ``
		 e.target.style.boxShadow=``
	}

	handleChangeTextArea(e){
		const{changeFieldValue}=this.props
		const wordCount =
      e.target.value === "" || e.target.value.match(/\S+/g) == null
        ? 0
		: e.target.value.match(/\S+/g).length;
		if (wordCount>1000) {

		}else{
			changeFieldValue('experience',e.target.value)
		}
	}

	resizeTextArea(e, addInfoId) {
		this.removeErrorMessage(addInfoId)
		var text = e.target

		var x = window.scrollX,
		  y = window.scrollY;
		text.style.height = "auto";
		text.style.height = text.scrollHeight + "px";
		text.style.overflowY = "hidden";
		text.scrollTop = text.scrollHeight;
		text.focus();
		window.scrollTo(x, y);
	}

	removeErrorMessage(addInfoId) {
		var elm = document.getElementById('js-is-error-mandatory-' + addInfoId)
		if(elm) {
			elm.innerHTML = ''
		}
	}

	handleFileSave(e){
		const{formValues,
		changeFieldValue,
		registrationSaveDataError}=this.props
		const data = new FormData();
		const file = e.target.files[0]

		if (typeof file != 'undefined') {
			if(file.size > 5000000){
				registrationSaveDataError(
					{file: ["file type cannot more than 5 MB."]}
				)
				this.setState({cvName:''})
			}else{
				registrationSaveDataError({})
				this.setState({uploadProgress:'up'})
					data.append("file", file  || []);
					data.append("type", "cv" || []);
					_axios({
						url: `/upload-cv`,
						timeout: 200000,
						method: 'post',
						data,
						onUploadProgress: progressEvent => {
							this.setState({cvName:file.name})
							const uploadPercentage = Math.round(
								(progressEvent.loaded * 100) / progressEvent.total
							);
							this.setState({uploadFilePercentage:uploadPercentage})


							// dispatch({
							//   type: "INTERVIEWS_ADD_UI_UPLOAD_VIDEO_PERCENTAGE_SUCCESS",
							//   upload_video_percentage: uploadVideoPercentage
							// });
						}
					})
					.then((data) => {
						registrationSaveDataError({})
						const fileresponse=data.data.file_name
						const filename = fileresponse.substring(fileresponse.lastIndexOf('/')+1);
						changeFieldValue('cv', fileresponse)
						this.setState({file:filename})
						this.setState({uploadProgress:'done'})
						console.log('success')
					})
					.catch((error) => {
						changeFieldValue('cv', '')
						this.setState({file:''})
						registrationSaveDataError(error.response.data.message)
						this.setState({uploadProgress:''})
						console.log('fail')
					})

			}
		}



	}

	

  	


	componentDidMount(){
		const { hashCandidateId, publicDocumentGetJobDetail,documentAttachment } = this.props
		// publicJobGetDetail(this.props.companySlug, this.props.jobSlugs)
		console.log(documentAttachment,'document attachment')
		publicDocumentGetJobDetail(hashCandidateId).then((publicJobDetail)=>{
			const _job = publicJobDetail.job
			if (_job.document_list) {
				this.setState({formDocumentList:JSON.parse(_job.document_list)})
				console.log(_job.document_list)
				// notes 0 not required or off ,1 optional ,2 required
				
			}
			// console.log(publicJobDetail)
		})

		// const company = JSON.parse(document.querySelector('#js-public-index-component').dataset.company)

		var timesRun=0

		this.setState({ name: '', email: '', code: '' })

		var interval=setInterval(() => {
			 timesRun += 1;
			if(timesRun === 100){
				clearInterval(interval);
			}

				$('li').each(function() {
						var $this = $(this);
					if($this.attr('style')){
						// console.log($(this).attr('style'));
						// $this.parent().addClass("class-new");
					}else{
						$this.attr("style", "list-style-position:outside")
					}
				});

			$('.rh5v-Overlay_inner').css('background-color', this.props.publicJobCustom.color)
		}, 100);

		window.onbeforeunload = function() { return true; }
	}



	checkExperience(value) {
		this.setState({experience: value})
	}

	handleFileUpload(e) {
		e.preventDefault()

		const file = e.target.files[0]

		this.setState({file})
	}

	removeRegexCharacter(str) {
		return str.replace(/[^0-9]/g, '')
	}

	removeSpaceCharacter(str) {
		if (str) {
			return str.replace(/\s/g, '')
		}
		return
	}

	imageOnError() {
		const {
			publicJobDetail,
			publicJobGetDetailAsync
		} = this.props

		publicJobDetail.company.logoUrl = imgDefaultLogo

		publicJobGetDetailAsync(publicJobDetail)
	}
	handleClickAfterSave(){
		if(this.state.isSaved || this.state.error_exist){
			var form = $("#form-registration").serializeArray();
			var returnArray = {};
	        for (var i = 0; i < form.length; i++){
	          returnArray[form[i]['name']] = form[i]['value'];
			}
			
			this.handleSaveData(returnArray)
		}
	}
	handleSaveData(values) {
		const {
			registrationSaveDataCode,
			publicJobDetail,
			translationjob,
			hashCandidateId,
			globalHideSweetAlert,
			globalAddSweetAlertData,
			publicJobCustom,
			touchForm,
			stopAsyncValidationForm,
			formState,
			reset,
			documentAttachment,
		} = this.props
		const {
			file,
			experience
		} = this.state
		let $this = this;
		var colorCustom = publicJobCustom.color
		const delay_start = publicJobDetail.job.delay_start 
		const company = publicJobDetail.company || {}
		const job = publicJobDetail.job || {}
		const detailJob : Map<string, any> = fromJS({detailInfo:translationjob})
		this.setState({isSaved: true})
		this.setState({error_exist: false})
		const translation : Map<string, any> = fromJS(translationjob.translation)
		// const company = JSON.parse(document.querySelector('#js-public-index-component').dataset.company)
		let not_success = 0;
		const fileAttachmentReducer  = documentAttachment.file_attachment
		const formDocumentList = this.state.formDocumentList
		let identifier_array = []
		// fileAttachmentReducer.map((value,index)=>{
		// 	if (value.status != 'success') {
		// 		identifier_array.push(value.identifier)
		// 	}
		// })
		const __updatedValuDocumentList=formDocumentList.map((doc,index)=>{
			
			let attachment = doc.attachment 
			if (attachment) {
				let updated_attachment = attachment.map((value,idx)=>{
					let identifier = value.identifier
					// identifier_array(value.identifier)
						fileAttachmentReducer.map((redvAL,idex)=>{
							if (identifier == redvAL.identifier) {
								value = redvAL
								if (redvAL.status !== 'finish') {
									not_success = 1
									value = redvAL
									value.errorMessage = 'Please retry to upload or delete the document.'
								}
								
							
							}
						})
						
						return value
				})
				doc.attachment  = updated_attachment
				return doc
			}
			return doc
			
		})	

		$this = this
		const new__updatedValuDocumentList = __updatedValuDocumentList.map((doc,index)=>{
			
			let link_input = doc.link_input 
			
			if (link_input) {
				let updated_link_input = link_input.map((res,idx)=>{
					
					// identifier_array(value.identifier)
						res.change = 1
						const result  = $this.checkLinkErrorValue(doc,idx,res)
						if (result != '') {
							not_success = 1
						}
						return res
				})
				doc.link_input  = updated_link_input
				
				return doc
			}
			return doc
			
		})	

		

		this.setState({formDocumentList:new__updatedValuDocumentList})

		

		if (not_success == 1) {
		
			return
		}


		return new Promise((resolve, reject) => {
			map(values, (data, callback) => {
			
				values.document_candidate = __updatedValuDocumentList
			
				callback(null, values)
			}, (error, results) => {
				// console.log(results)
				

				let isErrorMandatory = false
				console.log(publicJobDetail.additionalField)
				map(publicJobDetail.additionalField, (addinfo, callback) => {
					let value = ''

					if (addinfo.id === 77) {
						value = experience
					} else if (addinfo.input_type==1 || addinfo.input_type==0 ) {
							value = document.getElementsByClassName('js-additional-fields-'+addinfo.id)[0].value
					}else if(addinfo.input_type==2){
							value = formState[`${snakeCase(addinfo.label)}-${addinfo.id}`] || []
					}
					// console.log(value)
					if (addinfo.input_type==2 ) {
						if (addinfo.is_mandatory !== 0 && value.length < 1) {
								isErrorMandatory = true
								document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = `${addinfo.label} Field ${t(translation,'ERROR_BLANK')}`
								document.getElementById('btn-submit').removeAttribute("disabled")
							}else{
								isErrorMandatory = false

								document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = ""
								callback(null, {id : addinfo.id, value: value, is_mandatory: addinfo.is_mandatory, label : addinfo.label})
							}

					}else{

						if (isEmpty(value) && addinfo.is_mandatory !== 0) {
						isErrorMandatory = true
						document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = `${addinfo.label} Field ${t(translation,'ERROR_BLANK')}`
						document.getElementById('btn-submit').removeAttribute("disabled")
						}else if(addinfo.minWords && addinfo.is_mandatory !== 0){
							//checker for minwords
							if (this.countWord(value) < addinfo.minWords) {
								isErrorMandatory = true
								document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = `${addinfo.label} ${t(translation,'LABEL_AT_LEAST_HAVE')} ${addinfo.minWords} ${t(translation,'LABEL_WORDS')}`
								document.getElementById('btn-submit').removeAttribute("disabled")
							}else{
								isErrorMandatory = false

								document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = ""
								console.log('masuk callback')
								callback(null, {id : addinfo.id, value: value, is_mandatory: addinfo.is_mandatory, label : addinfo.label})
							}

						}	else {
							isErrorMandatory = false

							document.getElementById('js-is-error-mandatory-'+addinfo.id).innerHTML = ""
							console.log('masuk callback')
							callback(null, {id : addinfo.id, value: value, is_mandatory: addinfo.is_mandatory, label : addinfo.label})
						}

					}

				}, (error, results) => {
				
					if (isErrorMandatory === false) {
						// registrationSaveData(values, companySlug, jobSlugs)
						registrationSaveDataCode(values, hashCandidateId)
						.then((data) => {
							this.setState({ name: values.fullname, email: values.email, code: data.interview_code, url: data.url })
							if (data.assesment_not_available) {
								 	globalAddSweetAlertData({
										show: true,
										type: 'success',
										title: t(
												translation,
											'MODAL_SUCCESS_REGISTER_NO_ASSESMENT_TITLE'
									),
										html: true,
										text: t(
												translation,
											'MODAL_SUCCESS_REGISTER_NO_ASSESMENT_MESSAGE',
											{
													':candidate_fullname': values.fullname,
													':candidate_interview_code': data.interview_code,
													':candidate_email':values.email
											}
									),
										confirmButtonText: t(translation, 'MODAL_SUCCESS_REGISTER_NO_ASSESMENT_BUTTON'),
										confirmButtonColor: colorCustom,
										onConfirm: () => {
											// window.onbeforeunload = null
											// window.location = data.url
											reset('UploadExpired')
											$this.setState({isCompliance:false,isConsent:false})
											globalHideSweetAlert()
										}
										})
							}else{
									let description = t(
																					translation,
																				'MODAL_SUCCESS_REGISTER_MESSAGE',
																				{
																						':candidate_fullname': values.fullname,
																						':candidate_interview_code': data.interview_code,
																						':candidate_email':values.email,
																						':company_name':company.title
																				}
																			)
									if (job.device_type == 2) {
										description = t(
																					translation,
																				'MODAL_MOBILE_ONLY_SUCCESS_REGISTER_MESSAGE',
																				{
																						':candidate_fullname': values.fullname,
																						':code': data.interview_code,
																						':email':values.email
																				}
																			)
									}else if (job.device_type ==1){
										description = t(
																					translation,
																				'MODAL_DESKTOP_ONLY_SUCCESS_REGISTER_MESSAGE',
																				{
																						':candidate_fullname': values.fullname,
																						':code': data.interview_code,
																						':email':values.email
																				}
																			)
									}
									if (delay_start == 0) {
										window.onbeforeunload = null
										window.location = data.url
									}else{
										globalAddSweetAlertData({
											show: true,
											type: 'success',
											title: t(
													translation,
												'MODAL_SUCCESS_REGISTER_TITLE'
										),
											html: true,
											text: description,
											confirmButtonText: t(translation, 'MODAL_SUCCESS_BUTTON'),
											confirmButtonColor: colorCustom,
											onConfirm: () => {
												window.onbeforeunload = null
												window.location = data.url
												globalHideSweetAlert()
											}
											})
									}
									

						}




							// $('#registration-form').addClass("hide")
							// $('#registration-form__success').removeClass("hide")
							$('.js-job-detail-file').val('')

							this.setState({file: ''})

							return Promise.resolve()
						})
						.catch((error) => {
							this.setState({isSaved: false})
							if (typeof error.response == "undefined") {
								// TODO
							}else if(error.response.data.message == 'Our system is detecting that you have already applied to this job. You cannot apply twice. Please contact help@astrnt.co if you think there is an error'){
								// dispatch(registrationSaveDataError(error.response.data))
								touchForm(['email'])
								stopAsyncValidationForm({email:'ERROR_EMAIL_REGISTERED'})
								// console.log(error.response.data.message)
								this.setState({ error_exist: true })
							} else if(error.response.data.message =='Phone number already registered') {
								// TODO
								touchForm(['phone'])
								stopAsyncValidationForm({phone:'ERROR_MOBILE_NUMBER_REGISTERED'})
								console.log(error)
								this.setState({ error_exist: true })
							}else{

							}
							// reject(error)
						})
					} else {
						reject()
					}
				})
			})
		})
	}

	renderErrorNoTranslation({ meta: { touched, error } }) {
		console.log({ meta: { touched, error } },'for doc meta')
		return touched && error ? <div><span className="error normal" id="js-err-msg">{error}</span></div> : false
	}

	renderErrorFileState(message){
	 return message != '' ? <div><span className="error normal" id="js-err-msg">{message}</span></div> :''
	}

	renderError({ meta: { touched, error } }) {
		const {
			translationjob
		} = this.props
		// console.log({ meta: { touched, error } },'for any ')
		const translations : Map<string, any> = fromJS(translationjob.translation)
		return touched && error ? <div><span className="error normal" id="js-err-msg">{t(translations, error)}</span></div> : false
	}

	renderErrorCV({ meta: { touched, error } }) {
		const {publicJobDetail,translationjob} = this.props
		const job = publicJobDetail.job
		const translations : Map<string, any> = fromJS(translationjob.translation)
		return touched && error ? <div><span className="error normal" id="js-err-msg">{job.document_type+t(translations, error)}</span></div> : false
	}

	renderSubmitSuccess() {
		const parser: Object = new UAParser();
		const isMobile: boolean = parser.getDevice().type === 'mobile'
		const {translationjob} = this.props
		const translations : Map<string, any> = fromJS(translationjob.translation)

		if (isMobile) {
			const isiOS: boolean = parser.getOS().name === 'iOS'
			let sourceLogo: Object

			if (isiOS) {
				sourceLogo =
					<a href="https://itunes.apple.com/id/app/astronaut-always-be-interviewing/id1098124247?mt=8">
						<img src={imgAppStore} />
					</a>
			} else {
				sourceLogo =
					<a href="https://play.google.com/store/apps/details?id=co.astrnt.androidqa">
						<img src={imgGooglePlay} />
					</a>
			}
			return (
				<div className="big-panel p-40">
					<div className="text-center">
						<img src={imgSubmitted} className="m-b-24" alt="Application Submitted" />
						<h1 className="heading2 m-b-24">{t(translations, 'LABEL_APPLICATION_SUBMITED')}</h1>
						<p className="heading4 p-b-24">{t(translations, 'LABEL_CONGRATULATIONS')}, <b>{this.state.name}!</b> {t(translations,'LABEL_HAVE_SUCCESS_APPLIED')} <b>{this.state.email}</b> {t(translations, 'LABEL_WITH_LINK_TO_INTERVIEW')}.</p>
					</div>
					<p className="heading4">{t(translations, 'LABEL_TO_WAIT')}</p>
					<p className="heading4">{t(translations, 'LABEL_STEPS')}:</p>
					<p className="heading4">1. {t(translations, 'LABEL_STEPS_1')}:</p>
					{sourceLogo}
					<p className="heading4">2. {t(translations, 'LABEL_STEPS_2')}, <a href={this.state.url} className="text-inherit underline">{t(translations, 'LABEL_STEPS_2_1')}</a> {t(translations, 'LABEL_STEPS_2_2')}</p>
				</div>
			)
		} else {
			return (
				<div className="big-panel text-center p-40">
					<img src={imgSubmitted} className="m-b-24" alt="Application Submitted" />
					<h1 className="heading2 m-b-24">{t(translations, 'LABEL_APPLICATION_SUBMITED')}</h1>
					<p className="heading4 p-b-24">{t(translations, 'LABEL_CONGRATULATIONS')}, <b>{this.state.name}!</b> {t(translations,'LABEL_HAVE_SUCCESS_APPLIED')} <b>{this.state.email}</b> {t(translations, 'LABEL_WITH_LINK_TO_INTERVIEW')}.</p>
					<p className="heading4">{t(translations, 'LABEL_TO_WAIT_2')} <a href={this.state.url} className="text-inherit underline">{t(translations, 'LABEL_STEPS_2_1')}</a> {t(translations, 'LABEL_TO_DO_INTERVIEW_NOW')} <b>{this.state.code}</b> {t(translations, 'LABEL_ASTRONAUT_QNA_APP')}.</p>
				</div>
			)
		}
	}

 createMarkup(message) {
		return {__html: message};
	}

	handleVideoClick(companyId, videoId) {
		const { accessLog } = this.props
		accessLog(companyId,"intro_video",videoId);
	}

	render() {
		const {
			fields: {file},
			publicJobDetail,
			handleSubmit,
			submitting,
			pristine,
			errors,
			globalAddSweetAlertData,
			error_email_exists,
			globalSweetAlertData,
			formValues,
			publicJobCustom,
			formState,
			translationjob
		} = this.props
		const { experience,
		 isConsent,
		 isCompliance,
		 testColor,
		 uploadProgress,
		 isWhatsappReminder,
		 cvName } = this.state
		
		var countText: Number;
    const text_answer: String = formValues.experience==undefined ? '': formValues.experience;
		document.styleSheets[0].addRule('.main-gdpr-fluid .checkbox-container .checkmark:after', 'border: solid '+this.props.publicJobCustom.color+';');
		document.styleSheets[0].addRule('.whatsapp-box .checkbox-container .checkmark:after', 'border: solid '+this.props.publicJobCustom.color+';');
    if (text_answer.trim().length == 0 ) {
      countText = 0;
    } else {
      countText = text_answer == "" ? 0 : text_answer.match(/\S+/g).length;
	}

		// console.log(error_email_exists.toJS())
		const thisPageURL = window.location.href
		const company = publicJobDetail.company || {}
		const customColor = publicJobCustom.color
		const backgroundImage = publicJobCustom.backgroundImage
		const socialMedia = publicJobCustom.social_media

		const job = publicJobDetail.job || {}
		const dueDate = moment(publicJobDetail.due_date_doc).format("DD MMM YYYY")
		const additionalField = publicJobDetail.additionalField || []
		const gdpr_text = publicJobDetail.gdpr_text || []
		const gdpr_agreement_text = publicJobDetail.gdpr_aggrement_text || []
		const job_document_type = job.document_type == 'CV' ? 'Curriculum Vitae' : 'Company Investment Profile'
		const job_video_url = publicJobDetail.job ? publicJobDetail.job.introduction_video.job_video_url : ''
		const videoId = publicJobDetail.job ? publicJobDetail.job.introduction_video.job_video_id : ''
		const video = document.getElementById('video-src')
		const translations : Map<string, any> = fromJS(translationjob.translation)
		const label_apply = translations?t(translations, 'LABEL_APPLY_NOW'): ''
		const call_action_message = publicJobDetail.call_action_message || label_apply
		const show_email = job.email_required
		const show_due_date = publicJobDetail.show_due_date==null?1:publicJobDetail.show_due_date
		const translation : Map<string, any> = fromJS(translationjob.translation)
		console.log(publicJobDetail.show_due_date)
		console.log(show_due_date)
		let showWAoption = false
		if(job.whatsapp_notification && job.whatsapp_notification==1){
			showWAoption= true
		}
		let finalWidth = '100%'
		let videoStyle = {
			'width' : finalWidth,
			'borderRadius' : '10px',
		}
		$('.m-t-30 .button__primary').css('background-color', customColor)
		var iconClass;
		var iconColor;
		if (uploadProgress=='') {
			iconClass='fa-cloud-upload'
			iconColor='#999999'
		} else if (uploadProgress=='up') {
			iconClass='fa-soundcloud'
			iconColor=customColor
		} else if (uploadProgress=='done') {
			iconClass='fa-cloud'
			iconColor=customColor
		}
			if(video){
				video.onloadedmetadata = function() {
					if(video.videoHeight > video.videoWidth){
						video.style.width = '40%'
						video.style.left = '30%'
						video.style.position = 'relative'
					}
					if(video.videoHeight == video.videoWidth){
						video.style.width = '60%'
						video.style.left = '20%'
						video.style.position = 'relative'
					}
				}
			}
		return(
			<Fragment>
			{
				customColor=='' ?
				<div/>
				:
				<Fragment>
				 <div>
					<header className="header-career" style={{background:'#18244E'}} >
						<div className={`container ${backgroundImage=='' || backgroundImage==null || backgroundImage==0? '': 'invisible'}`}>
							<div className="flex-container img-container m-r-10 float-align-left">
								<a href={company.website}
									className="text-white"
									target="_blank"
									rel="noopener noreferrer">
									<img
										className="company-logo img-responsive"
										src={company.logoUrl}
										alt={company.title}
										onError={this.imageOnError} />
								</a>
							</div>
							<div className="header-detail vertical-item--center flex-between float-align-right text-right">
								<div>
									<h3 className="heading3 m-b-5">{company.title} - {job.title}</h3>
									<p className="font-16">{!isEmpty(job.jobType) ? <span>{job.jobType}</span>: '' }{!isEmpty(job.due_date) ? <span className="m-l-10">{show_due_date==1?<Fragment>&bull;&nbsp;&nbsp;{t(translations, "LABEL_DUE_DATE")}</Fragment>:''} <b>{show_due_date==1?dueDate:''} {show_due_date?renderTime(job):''}</b></span>: '' }</p>
								</div>
							</div>
						</div>
					</header>
					<section className="p-t-40 p-b-24 bg-gray" id="multidocupload-form">
						<div className="container" style={{maxWidth: '622px'}}>
							<div className="row">
								<div className="col-sm-12 col-md-12">
											<section id="section-registration" className="registration" style={{padding: '24px 70px 32px'}}>
												<div className='text-center div-finish-upload'>
													<img className='m-b-25' src={imgExpired} alt="" />
													<h1>{t(translation,'LINK_EXPIRED_LANDING_PAGE')}</h1>
													<p>{t(translation,'CANNOT_UPLOAD_EXPIRED_LINK_LANDING_PAGE')} <a href='mailto:help@astrnt.co' target='_blank'>help@astrnt.co</a> {t(translation,'CANNOT_UPLOAD_EXPIRED_LINK_LANDING_PAGE_CONT')}</p>
												</div>
											</section>
									
								</div>
							</div>
						</div>
					</section>
					<div className="footer-astrnt">
									<section>
											Powered by <a><img src={imgAstrntFooter} /></a> All Rights Reserved.
									</section>
							</div>
			
				</div>
				</Fragment>
			}
			</Fragment>

		)
	}
}

UploadExpired.propTypes = {
	errors: PropTypes.object,
	publicJobGetDetail: PropTypes.func.isRequired,
	companySlug: PropTypes.string,
	jobSlugs: PropTypes.string,
	registrationSaveData: PropTypes.func.isRequired,
	publicJobDetail: PropTypes.object.isRequired,
	fields: PropTypes.array.isRequired,
	publicJobGetDetailAsync: PropTypes.func.isRequired,
}

UploadExpired = reduxForm({
  form: 'UploadExpired',
	enableReinitialize: true,
	validate,
	fields
})(UploadExpired)
const selector = formValueSelector('UploadExpired')

const mapStateToProps = (state, ownProps) => {
	const formState = getFormValues('UploadExpired')(state)
	const publicJobDetail = state.publicJobDetail.toJS()
	const company = publicJobDetail.company || {}
	const job = publicJobDetail.job || {}

	const initialValues = {
		company_id: company.id,
		job_id: job.id,
		interview_code: job.open_code,
	}
	

  return {
		documentAttachment: state.documentAttachment.toJS(),
		publicJobDetail: state.publicJobDetail.toJS(),
		translationjob: state.publicJobDetail.toJS(),
		errors: state.registrationSaveDataError.toJS(),
		publicJobCustom: state.publicJobCustom.toJS(),
		error_email_exists: state.registrationEmailDuplicate,
		globalSweetAlertData: state.globalSweetAlertData.toJS(),
		hashCandidateId: ownProps.match.params.hashCandidateId,
		initialValues,
		formValues: selector(
			state,
			'cv',
			'experience',
			'whatsapp_notification'
		),
		formState
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
		changeFieldValue: (field, value) => dispatch(change('UploadExpired', field, value, true, true)),
		touchForm: (field) => dispatch(touch('UploadExpired', field)),
		stopAsyncValidationForm: (object) => dispatch(stopAsyncValidation('UploadExpired', object)),
		globalHideSweetAlert: () => dispatch(globalHideSweetAlert()),
		globalAddSweetAlertData: (options) => dispatch(globalAddSweetAlertData(options)),
		registrationSaveData: (companySlug, jobSlugs, values) => dispatch(registrationSaveData(companySlug, jobSlugs, values)),
		registrationSaveDataCode: (hashCandidateId, values) => dispatch(registrationSaveDataCode(hashCandidateId, values)),
		publicJobGetDetail: (companySlug, jobSlugs) => dispatch(publicJobGetDetail(companySlug, jobSlugs)),
		publicDocumentGetJobDetail: (hashCandidateId) => dispatch(publicDocumentGetJobDetail(hashCandidateId)),
		publicJobGetDetailAsync: (publicJobDetail) => dispatch(publicJobGetDetailAsync(publicJobDetail)),
		globalAddSweetAlertData:(option)=>dispatch(globalAddSweetAlertData(option)),
		globalHideSweetAlert:()=>dispatch(globalHideSweetAlert()),
		registrationSaveDataError:(error)=>dispatch(registrationSaveDataError(error)),
		reset:(formName)=>dispatch(reset(formName)),
		accessLog: (companyId, key, id) => accessLog(companyId, key, id),
		docAttachment:(file_attachment)=> dispatch(docAttachment(file_attachment)),
		docAttachmentUpload:(company_id,file,curr_index,up_time)=>dispatch(docAttachmentUpload(company_id,file,curr_index,up_time)),
		send:(company_id,file,extension,fileName,curr_index,end,start,size,new_file)=>dispatch(send(company_id,file,extension,fileName,curr_index,end,start,size,new_file)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UploadExpired)
